import React, { useEffect, useState } from "react";

const AppImage = ({
  src,
  alt,
  className = "",
  fallbackClassName = "",
  fallbackText = "Sin imagen",
  loading = "lazy",
  ...rest
}) => {
  const [hasError, setHasError] = useState(!src);

  useEffect(() => {
    setHasError(!src);
  }, [src]);

  if (hasError) {
    return (
      <div className={fallbackClassName || className} role="img" aria-label={alt}>
        {fallbackText}
      </div>
    );
  }

  return (
    <img
      {...rest}
      src={src}
      alt={alt}
      className={className}
      loading={loading}
      decoding="async"
      onError={() => setHasError(true)}
    />
  );
};

export default AppImage;
